export default {
  home: '홈페이지',
  aboutUs: '회사소개',
  productService: '상품&서비스',
  claims: '보험금 청구',
  questions: 'FAQ',
  contactUs: '문의하기',
  privacyPolicy: '개인정보처리방침',
  termsUse: '이용약관',
  login: '로그인',
  copyRight: function() { return '© ' + new Date().getFullYear() + ' Assura Asia. All Rights Reserved.'; },
  checkmore: '더 보기',
  slogan: ['의료미용 리스크 솔루션', '사고 발생 시 쉽게 대처할 수 있습니다'],
  contact: '온라인 문의',
  back: '이전',
  userName: '아이디',
  account: '계정',
  email: '이메일',
  password: '비밀번호',
  scroll: 'SCROLL',
  backtohome: '홈으로 돌아가기',
  iknowle: '알겠습니다',
  backtotop: 'TOP',

  // 首页
  home_aboutUs: '회사소개',
  home_aboutUs_desc: 'Assura Asia 는 2025년 스위스 Assura 그룹이 아시아 태평양 지역에 설립한 전액 출자 자회사입니다. 저희는 아시아 태평양 지역의 선도적인 혁신 보험사로서, 의료미용 기관과 개인 고객님들께 고품질 종합 보험 솔루션을 제공하는 데 주력하고 있습니다.',
  home_productService: '상품&서비스',
  home_productService_desc: '저희는 발생 가능한 사고와 위험을 더 잘 예방하고 보상하기 위해 보다 인간적인 보장 옵션을 설계하고 시행합니다. 동시에 아시아 태평양 지역의 의료미용 산업의 질적 발전을 효과적으로 촉진하는 것도 저희의 중요한 사명 중 하나입니다.',
  home_policyExchange: '교환',
  home_claims: '보험금 청구',
  home_claims_desc: '언제, 어디서나 저희의 온라인 플랫폼 또는 개인 컨설턴트를 통해 편리하고 효율적으로 보험금 청구를 시작할 수  있습니다.',

  // 关于我们
  aboutus_aboutUs: '회사소개',
  aboutus_aboutUs_desc: `Assura Asia 는 2025 년에 아시아 태평양 지역을 대상으로 설립된 스위스 Assura 그룹의 전액 출자 자회사이며, 아시아 태평양 지역의 선도적인 의료미용 전문 보험사입니다.
저희는 의료미용 기관과 개인 고객님께 맞춤형 고품질 종합 보험 솔루션을 제공하고 있습니다.

최근 의료미용 산업의 혁신적인 발전과 함께 전문적인 보험 서비스의 중요성이 더욱 높아지고 있습니다.
Assura Asia 는 기존 고객과 잠재 고객님들께 보다 안전하고 효율적인 보장을 제공하기 위해 보험 상품과 서비스를 지속적으로 혁신하고 있습니다.`,

  aboutus_mission: '취지와 가치관',
  aboutus_mission_desc: `저희의 취지와 가치관은 대외 업무와 내부 관리를 넘어
진심을 담는 <em>상호 존중</em>과 <em>끊임없는 탁월함 추구</em>가 항상 Assura Asia 의 핵심과 초석이 되어 왔습니다`,
  aboutus_mission_1_title: `고객존중 제일`,
  aboutus_mission_1_desc1: `고객 만족은 곧 우리의 성공입니다.`,
  aboutus_mission_1_desc2: `모든 상황에서 고객의 요구를 더 잘 경청하고 효과적인 지원을 제공하는 것이 우리의 가장 근본적인 사업 원칙입니다.`,
  aboutus_mission_2_title: `객관적인 일처리`,
  aboutus_mission_2_desc1: `모든 사태는 다면성과 복잡성을 갖추고 있습니다.`,
  aboutus_mission_2_desc2: `저희는 객관적이고 공정한 태도로 업무 중의 모든 기회와 위험을 평가하여, 모든 결정과 결론을 더 인간적이고 합리화하도록 합니다.`,
  aboutus_mission_3_title: `일심동체`,
  aboutus_mission_3_desc1: `저희는 모든 구성원을 존종합니다.`,
  aboutus_mission_3_desc2: `팀의 화합과 노력 없이는 우수한 기업을 만들 수 없다는 사실을 깊이 이해합니다. 엘리트 주도의 우수한 근무 환경을 조성함으로 인재들이 보다 평등하고 편안한 개발 기회를 누릴 수 있습니다.`,
  aboutus_mission_4_title: `사회적 책임`,
  aboutus_mission_4_desc1: `저희는 훌륭한 기업 국민이 될 것을 자랑스럽게 생각합니다.`,
  aboutus_mission_4_desc2: `사회환원과 다양한 유형의 사회 활동을 지원하는 것에 주력합니다. 저희의 전략적 방향 전환은 아시아 시장에서 Assura Asia의 새로운 포지셔닝을 의미하며, 가까운 미래에 더 많은 미지의 도전에 직면하더라도 최선을 다할 것입니다.`,

  aboutus_leadership: '경영진 소개',
  aboutus_leadership_desc: `경력 많은 동료들과 함께 미지의 도전에 직면합니다.
<em>예기된 사회적 가치 창출</em> 극대화`,
  aboutus_leadership_1_name: ['Bharat W. Lester', 'Bharat W. Lester'],
  aboutus_leadership_1_poi: 'CEO',
  aboutus_leadership_1_desc: `레스바는 Assura Asia 의 CEO로서 보험 업계에서 20년 이상의 경력을 가지고 있으며, 2025년부터 스위스 본사의 아시아 태평양 지역 업무의 운영 및 반전을 총괄하고 있습니다. 
Assura Asia 스위스 본사에 합류하기 전에 스위스국립과학재단(SNSF)에서 의료미용 분야의 다양한 운영 및 관리 업무를 맡았으며, 그 후에 시그나 코퍼레이션(Cigna), 푸르덴셜(Prudential plc) 등의 회사에서 폭넓은 고위 관리 경험을 쌓았습니다.`,
  aboutus_leadership_2_name: ['Max Lee', 'Max Lee'],
  aboutus_leadership_2_poi: 'CRO',
  aboutus_leadership_2_desc: `이경홍은 Assura Asia 의 CRO(최고 리스크 관리자)이다. 회사의 모든 리스크 관리, 존법 및 법률 문제를 담당하고 있다. 2019년에 입사하여 아시아 태평양 및 국제 보험 시장에서 15년 이상 경력을 가지고 있으며, 보험 통계, 준비금 및 재무 관리 등 다양한 영역에 걸쳐 있다. 서울대학교에서 졸업하고 경제학 박사학위를 취득하였다.`,
  aboutus_leadership_3_name: ['Cathy Ng', 'Cathy Ng'],
  aboutus_leadership_3_poi: 'CFO',
  aboutus_leadership_3_desc: `오개흔은 Assura Asia 의 CFO(최고 재무 관리자)이다. 모든 재무 보고, 계획 및 모니터링의 관리와 총괄을 담당하고 있다. 2015년에 스위스 본사에 입사한 후에 여러 자회사의 이사를 겸임하고 있다. 업계에서 15년 이상의 경력을 가지고 있으며, Assura Asia에 입사하기 전에는 언스트앤영(Emst&Young)에서 경영진으로 근무하였다. 국립싱가포르대학교에서 졸업하고 회계학 학사학위를 취득하였고, 스탠퍼드대학교 경영학 석사학위를 취득하였다.`,
  aboutus_leadership_4_name: ['Aaron Lim', 'Aaron Lim'],
  aboutus_leadership_4_poi: '아태구 업무부 부사장',
  aboutus_leadership_4_desc: `임사운은 Assura Asia 의 아시아 태평양구 업무부 부사장이다. 회사의 제품 관리 및 비즈니스 개발을 담당하고 있다. 2021년에 입사하였으며, 업계에서 15년 이상의 고위 관리 경력을 가지고 있다. 그 전에는 앨러간(Allergan plc) 아시아 태평양 본사에서 근무하였으며, 의료미용 업계에서 풍부한 인맥과 자원을 갖고 있다. 홍콩중문대학교에서 졸업하고 학사학위를 취득하였다.`,
  aboutus_leadership_5_name: ['Satomi Nagano', 'Satomi Nagano'],
  aboutus_leadership_5_poi: '아태구 인사부 부사장',
  aboutus_leadership_5_desc: `나가노 사토미는 Assura Asia 의 아시아 태평양구 인사부 부사장이다. 인력 자원 전략 추진을 담당하고 있으므로 회사의 발전 목표 달성을 촉진하는 데에 기여해 왔다. 2025년에 입사하여 회사의 운영, 연구 개발, 사업 개발 등의 인력 자원 분야에서 중요한 가치를 창출하였으며, 아시아 태평양 지역의 각 지사에게 가장 가치 있는 후보자 및 사업 파트너를 지속적으로 발굴하고 발전시키고 있다. 도쿄대학교에서 졸업하고 경영학 학위를 취득하였다.`,

  aboutus_corporate: '기업의 사회적 책임',
  aboutus_corporate_desc: `그 동안,
Assura Asia 는 더 많은 환자와 기업의 리스크를 줄임으로써 업계의 번영에 기여해 왔습니다.
동시에, 저희는 내부 및 외부 동료들을 적극적으로 이끌어
<em>더 많은 사랑과 관심으로 더 나은 세상을 만들기 위해 노력하고 있습니다</em>.`,
  aboutus_corporate_1_title: `의료지원`,
  aboutus_corporate_1_desc: `각계의 자선 단체 및 팀과 장기적인 파트너십을 구축하여 사회에 긍정적인 변화와 발전을 가져오는 것을 목표로 합니다.`,
  aboutus_corporate_2_title: `사회적 보호`,
  aboutus_corporate_2_desc: `교육, 환경 보호, 의료 및 건강 관리, 자원봉사 등을 지원하는 방식으로 커뮤니티의 전반적인 복지를 향상시킵니다.`,
  aboutus_corporate_3_title: `환경 보호`,
  aboutus_corporate_3_desc: `오염을 줄이고 자원을 절약하며 지속 가능한 개발과 그린에너지 프로젝트를 촉진함으로써 환경에 미치는 부정적인 영향을 줄입니다.`,

  aboutus_joinus: `인재채용`,
  aboutus_joinus_title: `인재
  채용`,
  mobile_aboutus_joinus_title: `인재채용`,
  aboutus_joinus_intro1: `아시아 태평양 지역에서 Assura Asia 의 업무는 싱가포르, 홍콩(중국), 인도네시아, 말레이시아, 태국, 한국, 일본에 진출해 있으며, 앞으로 더 많은 국가에 진출할 계획이므로 더 많은 인재를 확보하는 것이 회사의 발전을 위한 핵심입니다.

저희는 항상 다양한 인력 자원 채널을 통해 적합한 인재를 찾고 있습니다. 저희가 이상적인 지원자는 기본적인 실무 경험 외에 뛰어난 커뮤니케이션 능력, 글쓰기 능력, 팀워크 능력을 갖추고 있어야 합니다.`,
  aboutus_joinus_intro2: `* Assura Asia 는 기회 균등 고용주입니다. 저희는 인종, 피부색, 종교적 신념, 종교, 성별, 임신, 국적, 혈통, 시민 신분, 연령, 혼인, 또는 배우자 관계 상황, 성적 지향, 성 정체성 표현, 장애, 의료 상태, 유전 정보 혹은 경향, 퇴역 군인 혹은 군인 신분, 가정 폭력 피해자 신분 또는 법적으로 보호되는 다른 모든 범주에 관계없이 자격에 맞는 모든 구직자를 차별하지 않습니다. 저희는 모든 적용 가능한 법률을 준수하며, 지원자에게 합리적인 장애인 편의시설을 제공합니다(필요한 경우).
  
  <span class="bold ffen">관련된 제3자 플랫폼에서 현재 채용 중인 직책에 대해 문의하고자 하시면 이메일에 귀하의 자세한 이력서를 첨부하여 연락 주시기 바랍니다.</span>
<span class="link ffen">career@assuraasia.com</span>`,

  // 产品与服务
  productservice_productService: `상품&서비스`,
  productservice_productService_desc: `의료미용 수술은 현재 외모와 체형을 가장 효과적으로 개선할 수 있는 의료 기술입니다. 피부에 불가피한 상해를 줄 수 있기 때문에 외모나 체형을 개선하는 과정에서 다양한 잠재적인 사고가 발생할 수 있습니다.
저희는 보다 인간적인 보장 옵션을 설계하고 실행하여 발생할 수 있는 사고와 위험을 더 잘 예방하고 보상합니다. 또한 아시아 태평양 지역의 의료미용 산업의 질적 발전을 효과적으로 촉진하는 것도 저희의 중요한 사명 중 하나입니다.`,

  productservice_coveragePlans: `보장계획`,
  productservice_coveragePlans_person: `수술 전 사고 보장`,
  productservice_coveragePlans_person_desc: `탁월한 언더라이팅 솔루션, 전문적인 시장 인사이트와 풍부한 임상 경험을 바탕으로 예측할 수 없는 사고 발생 시 효과적인 보장을 제공합니다.`,
  productservice_coveragePlans_unit: `기관적 책임 보장`,
  productservice_coveragePlans_unit_desc: `혁신적인 서비스와 상품의 결합을 통해 의료 기관과 환자 간의 소통 및 만족도를 최적화하여 사고로 인한 기관의 명예와 경제적 손실을 방지합니다.`,

  productservice_partners: `파트너십`,
  productservice_partners_axa: `AXA`,
  productservice_partners_nissay: `NISSAY`,
  productservice_partners_hsbc: `HSBC`,
  productservice_partners_sl: `Singlife `,
  productservice_partners_aia: `AIA`,

  // 索偿
  claims_claims: `보험금 청구`,
  claims_claims_desc: `언제 어디서나, 
저희의 온라인 플랫폼 또는 개인 컨설턴트를 통해 편리하고 효율적으로 보험금 청구를 시작할 수 있습니다.

저희는 최대한 빠르게 당신의 신청을 처리하고, 진심 어린 위로와 관심을 보내드립겠습니다.`,

  claims_application_inquiry: `보험금 청구 신청 및 조회`,
  claims_application_inquiry_desc: `보험금 청구 신청을 빠르게 제출하고 진행 상황을 언제든지 확인할 수 있으며, 편리한 온라인 셀프 서비스와 개인 컨설턴트를 통해 당신의 권익을 보장해드립니다.`,
  claims_application_inquiry_method1_title: `온라인 셀프 서비스`,
  claims_application_inquiry_method1_desc: `언제 어디서든 당신의 보험금 청구 요구와 진행 상황을 파악하여 업무를 간소화합니다.`,
  claims_application_inquiry_method2_title: `개인 컨설턴트 서비스`,
  claims_application_inquiry_method2_desc: `온라인 문의 플랫폼을 통해 고객센터와 즉시 연결하여 귀하의 요청을 상담해 보세요.`,
  claims_application_inquiry_login: '로그인',

  // 常见问题
  faq_faqs: 'FAQ',
  faq_faqs_desc: `의료미용 보험에 대해 자주 묻는 질문을 답변해 드림으로 보험금 청구 절차, 보험혜택 및 서비스 세부사항에 대해 쉽게 알아볼 수 있게 해드립니다. 

더 자세히 알고 싶으신가요? 온라인 문의로 바로 요구를 전달하세요.`,
  faplist: [
    {
      question: `의료미용이란 무엇인가요? 주요 종류는 어떻게 되나요?`,
      ans: `의료미용은 수술, 약물, 의료 기기 및 기타 외상성, 침습적 또는 비침습적 의료 기술을 통해 인간의 외모 또는 각 부위를 미화, 개선, 복원 및 재생하는 미용 방식을 말합니다.

의학적 관점에서 의료미용은 주로 침습적 미용(성형)과 비침습적 미용(쁘띠 성형) 두 가지로 나눌 수 있습니다. 침습적 미용에는 가슴 확대 성형, 지방 흡입, 코성형, 눈성형 등과 같은 수술적 미용 방법이 포함되며, 비침습적 미용에는 레이저치료, 리프팅, 쁘띠 성형 주사 등과 같은 시술적 미용 방법이 포함됩니다.`},
    {
      question: `의료미용 수술을 받기 전에 어떤 준비를 해야 되나요?`,
      ans: `일반적으로 수술 전에는 다음과 같이 준비하는 것을 권장합니다.

1.세부 상담: 자신의 현재 상황과 요구 사항에 의해 전문적인 의료기관과 함께 전방위로 상담하고 알아보아야 합니다.
2.심리적 준비: 생활과 직장에서 수술로 인해 발생할 수 있는 잠재적인 변화나 영향에 대해 어느 정도의 준비와 인식이 있어야 합니다.
3.병원 선택: 의료 자격, 시장 평판, 의사의 경험, 서비스 및 가격 등의 측면에서 종합적으로 고려하여 자신에게 적합한 병원을 선택해야 합니다.
4.수술 시간 계획: 수술 및 수술 후 회복 시간을 계획하고 임신, 모유 수유 또는 생리 주기 등을 피하여 계획해야 합니다.
5.적절한 수술 전 검진: 정기적인 건강검진을 통해 고혈압, 심장 질환, 응고 장애 등과 같은 불필요한 수술 전 위험을 제거해야 합니다.
6.수술 동의서 서명: 의료 기관이 수술에  엄격함을 확인하고 본인에 대한 법적 보호를 확보해야 합니다.
7.보험 상품 구매: 사고 발생 시 확실한 보상과 보호를 받을 수 있고 갑작스러운 의료비 지출과 심리적 변화 에 대처할 수 있도록 해야 합니다.`,
    },
    {
      question: `인수심사란 무엇인가요? 절차가 어떻게 되나요?`,
      ans: `보험 가입 시 보험사가 피보험자에 대해 위험평가를 하는 과정은 인수심사라고 합니다.

일반적으로 보험사는 피보험자의 과거 병력, 사진 등과 같은 개인 건강 관련 자료를 수집하여, 이에 따라 적절한 위험 평가를 진행하고 기록을 남긴 후 보험 인수 여부 및 제공할 수 있는 보장 범위를 결정합니다.`,
    },
    {
      question: `패스트패스(FastPass)란 무엇인가요?`,
      ans: `일부 특정 국가나 지역에서는 빅데이터의 분석과 경험을 바탕으로 간소화된 인수 절차를 적용하여 전체적으로 보험 가입 시간을 크게 절감할 수 있습니다.

피보험자는 보험 가입 신청 시 시스템 또는 공식 설문지를 통해 나이, 성별, 거주지 등과 같은 간단한 개인 정보와 과거 병력 등과 같은 건강 관련 질문에 답하기만 하면 되며, 별도의 건강 진단서를 제출할 필요 없이 5분 이내에 신청이 완료될 수 있습니다.

온라인 보험 가입은 최대선의의 원칙(The principle of utmost good faith)을 준수하고 절차가 자동화되므로 피보험자는 일반적인 절차에 비해 더 빠르게 보험증권을 받을 수 있습니다.`,
    },
  
    {
      question: `보험 가입 시 왜 건강 설문지를 작성해야 하나요?`,
      ans: `보험사는 고객님의 건강 상태에 따라 고객님의 예상 사망률, 장애율 및 기타 보험 사고 발생률을 분류하고 선별한 후 보험 인수 여부 및 인수 조건을 결정합니다. 고객님의 건강 상태에 대한 정보는 주로 다양한 건강 설문지를 통해 수집되므로 고객님은 보험 가입 시 건강 설문지를 정확하게 작성하고 설문지에 포함된 모든 질문에 대한 고지의무가 있습니다.`,
    },
    {
      question: `최대선의의 원칙이란 무엇인가요?`,
      ans: `최대선의의 원칙이란 보험사가 피보험자가 보험 인수 시 개인 상황 및 건강 상태를 진실하고 정확하게 고지했다고 믿는다는 원칙을 의미합니다. 만약 보험회사가 나중에 피보험자가 중요한 정보를 은폐하거나 고지하지 않은 사실을 발견할 경우, 보험금 청구를 거절할 권리가 있으며 보험 계약을 해지할 권리도 있습니다.`,
    },
    {
      question: `인수심사에 실패하는 이유는 무엇인가요?`,
      ans: `보험사가 인수심사 과정에서 피보험자에게 보장을 제공할 위험이 과대하고 허용 범위를 초과한다고 판단하는 경우, 인수심사가 거절될 가능성이 있습니다.`,
    },
    {
      question: `보험금 청구 진행 상황과 내역을 어떻게 확인할 수 있나요?`,
      ans: `본 웹사이트의 개인 고객 계정에 로그인한 후, 메뉴에서 ‘청구 기록’을 선택하여 진행 상황과 내역을 조회할 수 있습니다. 물론, 전담 상담원에게 직접 문의하거나 고객센터로 전화하여 최신 정보를 확인할 수도 있습니다.`,
    },
    {
      question: `보험금은 어떻게 받을 수 있나요?`,
      ans: `저희는 고객님이 보험금 청구 시 선택한 결제 방법에 따라 보험금을 지급합니다. 결제 방법을 선택하지 않았거나 선택한 결제 방법이 사용될 수 없는 경우, 고객님의 개인 계정에 설정된 결제 방법에 따라 지급합니다.`,
    },
    {
      question: `보험금지급을 신청하려면 무슨 조건이 필요한가요?`,
      ans: `일반적으로, 보험금 청구는 보험계약자 또는 피보험자가 신청할 수 있으며, "사망 보험금 청구"는 수익자가 신청할 수 있습니다.`,
    },
    {
      question: `일반적으로 보험금 청구 수리는 얼마나 걸리나요?`,
      ans: `보험금 청구 페이지에 명시된 필수 서류를 접수한 후, 일반적으로 5-10영엽일 내에 청구 결과 또는 진행 상황을 알려드립니다. 저희는 최대한 빠르게 모든 청구를 처리할 것을 승낙하지만, 실제 소요 시간은 청구 유형, 사건의 복잡성 및 제출된 서류의 완전성 등에 따라 달라질 수 있습니다.`,
    },
    {
      question: `수술 후 실제 결과와 기대 효과 간의 차이는 어떻게 정의하나요?`,
      ans: `고객님은 개인 컨설턴트나 파트너십 의료 기관에 문의하여 관련 보험 정첵 약관을 요청할 수 있습니다. 또한 본 사이트에서 개인회원 로그인하고 '나의 보험' 페이지에서 자세한 내용을 확인할 수 있습니다.`,
    },
    {
      question: `보험계약 관련 서류 조회는 어떻게 하나요?`,
      ans: `보험가입이 승낙된 후 본 사이트에서 개인회원 로그인하고 '나의 보험' 페이지에서 자세한 내용을 조회할 수 있습니다.`,
    }
  ],

  // 联系我们
  contactus_contactUs: '문의하기',
  contactus_contactUs_desc: `귀하의 모든 질문에 신속하고 정확하게 답변해 드리겠습니다.`,
  contactus_inquiryType: `문의 유형`,
  contactus_inquiryType1: `문의 유형을 선택해 주세요`,
  contactus_inquiryType1Options: [
    '수술 전 사고 보장 문의',
    '기관적 책임 보장 문의',
    '전담 고객센터 연결',
    '보험 혜택 교환',
    '업무 협력',
    '미디어 관계',
    '불만 및 제안',
    '기타'
  ],
  contactus_countryOptions: [
    '싱가포르',
    '일본',
    '대한민국',
    '말레이시아',
    '태국',
    '중국',
    '홍콩, 중국',
    '마카오, 중국',
    '다른 지역',
  ],
  contactus_countryCodeOptions: [
   '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
  ],
  reset_countryCodeOptions: [
   '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
    '다른',
  ],
  contactus_inquiryType2: `문의하고 싶은 내용을 입력해 주세요`,
  contactus_contactInformation: `고객정보`,
  contactus_contactInformation1: `고객정보`,
  contactus_contactInformation2: `성`,
  contactus_contactInformation3: `여성`,
  contactus_contactInformation4: `남성`,
  contactus_contactInformation5: `국가`,
  contactus_contactInformation6: `도시`,
  contactus_contactInformation7: `국제전화국번`,
  contactus_contactInformation8: `전화번호 입력해 주세요`,
  contactus_submit_protocol: `아래 버튼을 클릭하면 <a class="ffen" href="/protocol/private">개인정보 처리방침</a> 및 <a class="ffen" href="/protocol/term">이용약관에</a> 동의하는 것으로 간주됩니다`,
  contactus_submit: `문의신청`,
  result_feedback: `메시지를 보내주셔서 감사합니다.
내용을 확인한 후, 최대한 빠르게 연락드리겠습니다.`,
  error_required_cannot_empty: '필수 입력란은 비워둘 수 없습니다',

  contactus_offices: '아시아 태평양 지역 사무소',
  contactus_offices_list: [
    { 
      name: '싱가포르', 
      address: `마리나 베이 파이낸셜 센터 타워 239층`, 
      contact: '+65 6565 7722', 
      email: 'sg@assuraasia.com' 
    },
    { 
      name: '일본', 
      address: `도쿄도 치요다구 마루노우치 1-8-3마루노우치 트러스트 타워 본관 20층`, 
      contact: '+83 03 5288 6288', 
      email: 'jp@assuraasia.com' 
    },
    { 
      name: '대한민국', 
      address: `서울파이낸스센터 21층`, 
      contact: '+82 2 3888 6789', 
      email: 'kr@assuraasia.com' 
    },
    { 
      name: '중국 홍콩', 
      address: `홍콩 센트럴 플라자 35층`, 
      contact: '+852 6567 6688', 
      email: 'hk@assuraasia.com' 
    },
  ],

  // 保障计划
  plan_person: `수술 전 사고 보장 계획`,
  plan_person_desc: `혁신적인 서비스와 상품의 결합을 통해 의료 기관과 환자 간의 소통 및 만족도를 최적화하여 사고로 인한 기관의 명예와 경제적 손실을 방지합니다.`,
  plan_unit: `기관적 책임 보장 계획`,
  plan_unit_desc: `혁신적인 서비스와 상품의 결합을 통해 의료 기관과 환자 간의 소통 및 만족도를 최적화하여 사고로 인한 기관의 명예와 경제적 손실을 방지합니다.`,
  plan_btn_applynow: `바로신청`,
  plan_btn_manual: `상품설명`,
  
  plan_coverage: `보장 범위`,
  plan_coverage_1: `안면윤곽`,
  plan_coverage_2: `코 성형`,
  plan_coverage_3: `눈 성형`,
  plan_coverage_4: `가슴 성형`,
  plan_coverage_5: `지방 성형`,
  
  plan_person_coverage_list_1_title: `사고로 인한 사망`,
  plan_person_coverage_list_1_desc: `의료미용 수술 중 사고로 인한 사망 위험을 보장하여 가족에게 경제적 지원을 제공하고 돌발상황으로 인한 스트레스를 완화합니다. `,
  plan_person_coverage_list_2_title: `기능적 손상`,
  plan_person_coverage_list_2_desc: `의료미용 수술로 인한 신체 기능 손상을 포함한 기능적 손상에 대한 보상을 보장하여 사고 발생 시 고객을 적절히 보호할 수 있도록 합니다.`,
  plan_person_coverage_list_3_title: `수술 사고`,
  plan_person_coverage_list_3_desc: `수술 중 사고에 대한 보장을 제공하여 의료 실수 또는 장비 고장으로 인한 상해를 포함하고 고객의 법적 권익을 보장합니다.`,
  plan_person_coverage_list_4_title: `정량화된 만족도`,
  plan_person_coverage_list_4_desc: `정량화 가능한 보상 범위와 기준을 통해 수술 중의 실수와 부작용에 대한 배상금을 지불함으로써 고객에게 더 나은 의료미용 경험을 제공하기 위해 최선을 다하고 있습니다.`,

  plan_unit_coverage_list_1_title: `의료 책임 보장`,
  plan_unit_coverage_list_1_desc: `치료 또는 수술 사고로 인한 환자 사망 시 책임 보상 및 사후 처리 비용을 보장하고 유가족 위로 및 여론 대응을 지원하여 기관에 미치는 영향을 줄리는 데 돕니다.`,
  plan_unit_coverage_list_2_title: `기능적 손상`,
  plan_unit_coverage_list_2_desc: `의료 작업으로 인한 환자의 기능적 손상에 대한 보상 및 수술 후 복구 비용을 보장하여 기관의 재정적 부담을 완화하고 환자의 권익을 보호합니다.`,
  plan_unit_coverage_list_3_title: `수술 사고`,
  plan_unit_coverage_list_3_desc: `장비 고장 또는 작업 실수로 인한 수술 사고에 대한 보상 및 치료비를 보장하고 환자의 수술 후 재활 관련 비용을 지원합니다.`,
  plan_unit_coverage_list_4_title: `정량화된 만족도`,
  plan_unit_coverage_list_4_desc: `정량화 가능한 보상 범위와 기준을 통해 수술 중의 실수와 부작용에 대한 배상금을 지불함으로써 고객에게 더 나은 의료미용 경험을 제공하기 위해 최선을 다하고 있습니다.`,

  plan_features: `계획 특징`,
  plan_person_features_1_title: `FASTPAY™️`,
  plan_person_features_1_desc: `온라인으로 보험금 청구
빠르게 지급 받기.`,
  plan_person_features_2_title: `개인 컨설턴트`,
  plan_person_features_2_desc: `1:1 전문 상담
객관적인 솔루션 조언.`,
  plan_person_features_3_title: `맞춤형 보험계약`,
  plan_person_features_3_desc: `보장 내용을 유연하게 선택
고객 맞춤형 보험계약.`,
  plan_person_features_4_title: `해외 의료 컨시어지 서비스`,
  plan_person_features_4_desc: `아시아 태평양 지역의 다양한 의료 자원
언제나 필요한 지원 제공.`,

  plan_unit_features_1_title: `FASTPAY™️`,
  plan_unit_features_1_desc: `온라인으로 보험금 청구
빠르게 지급 받기.`,
  plan_unit_features_2_title: `포괄적 보증 강화`,
  plan_unit_features_2_desc: `환자 신뢰도 강화
의료 기관의 서비스 다원화 역량 강화.`,
  plan_unit_features_3_title: `운영 위험 이전`,
  plan_unit_features_3_desc: `사고 발생에 대한 효과적인 대처
운영 스트레스 감소.`,
  plan_unit_features_4_title: `전담 팀 지원`,
  plan_unit_features_4_desc: `다양한 전문적인 지원
위험 사고 발생 시 효율적인 협동 및 처리.`,

  plan_moreinfo: `자세한 정보`,
  plan_moreinfo_desc: `온라인으로 문의하고 요구 사항을 바로 알려주세요`,
  plan_moreinfo_slogan: `의료미용 리스크 솔루션
사고 발생 시 쉽게 대처할 수 있습니다 `,
  plan_moreinfo_nores: `면책 조항`,
  plan_moreinfo_nores_desc: `Assura Asia 및 관련 회사, 계열사, 자회사는 특정 목적, 제품 전시 또는 추천을 포함하되 이에 국한되지 않는 모든 명시적 및 묵시적 보증을 부인합니다. 사용자는 제공된 의견, 조언, 서비스 및 기타 정보의 정확성, 완전성, 유용성을 평가할 책임이 있으며, 개인 상황에 따라 법률, 의료 등 관련 전문가에게 상담해야 합니다. Assura Asia 및 관련 회사, 계열사, 자회사는 회사 웹사이트 또는 모든 전시 자료의 사용으로 인해 발생하는 직접적, 간접적, 특별, 우발적, 필연적 손해에 대해 책임지지 않습니다.`,

  // 登录
  login_loginType: `아이디 유형을 선택해 주세요`,
  login_loginType_desc: `당신의 보장계획 또는 관련 업무의 최신 진행상황 조회 및 관리`,
  login_loginType_1_title: '개인회원',
  login_loginType_1_desc: '수술 전 사고 보장계획',
  login_loginType_2_title: '기업회원',
  login_loginType_2_desc: '기관적 책임 보장계획',
  login_loginType_3_title: '대리 및 에이전시',
  login_loginType_3_desc: '업무 관리',
  login_forget_password_tip: `비밀번호를 잊으셨나요? `,
  login_forget_password_find: '비밀번호 찾기',
  login_noaccount_tip: `아이디가 없으신가요?`,
  login_regsiter_now: '회원가입',
  login_error_account: '사용자 이름 또는 이메일 주소가 올바르지 않습니다. 다시 시도해 주세요.',
  login_error_password: '잘못된 비밀번호입니다. 다시 시도해 주세요.',

  // 兑换
  exchange_title: '혜택 교환',
  exchange_welcome_txt: '	다시 오신 것을 환영합니다，Oli',
  exchange_loginType_1_title: '카드 코드 정보',
  exchange_loginType_1_plsholder: '교환 코드',
  exchange_loginType_1_error: '잘못된 키입니다. 다시 시도해 주세요.',
  exchange_description_title: '교환 안내',
  exchange_description_txt: ` · 교환 카드는 연동 후 해제나 계정 변경이 불가능합니다.
 · 개인 센터에서 보장을 교환하세요.
 · 문의는 고객센터 또는 담당자에게 하세요.`,
  exchange_btn: '혜택 교환',

  // 注册
  register_title: '계정 정보',
  register_account: '아이디	',
  register_account_tip: '3-20자 (영문, 숫자, _)',
  register_account_exist: '账号已存在，请重试',
  register_email:'이메일',
  register_email_tip: '이메일 형식 확인',
  register_email_exist: '邮箱已存在，请重试',
  register_password: '비밀번호 설정',
  register_password_tip: '7자 이상 (대소문자, 숫자 포함)',
  register_password_tip_mobile:`7자 이상 (대소문자, 숫자 포함)`,
  register_password_again: '비밀번호 확인',
  register_password_again_error: '비밀번호 불일치',
  register_promo_code:'초대코드',
  register_promo_code_error:'초대코드 오류',
  next: '다음',
  register_cancel_btn: '취소',
  placeholder_common: '입력',

    //找回密码
    reset_password_title: '비밀번호 찾기',
    reset_password_subtitle: '이메일/휴대폰으로 재설정',
    reset_password_menu: '방법 선택:',
    reset_password_email: '가입한 이메일 입력',
    reset_password_mobile:'	가입한 휴대폰 번호 입력',
    reset_no_account: '미등록 계정',

    //cookie
  cookie_accept_title: '쿠키 설정',
  cookie_accept_context: '“수락”를 클릭하면 웹사이트 탐색을 향상하고, 사이트 사용을 분석하며, 마케팅 활동을 지원하기 위해 귀하의 장치에 쿠키를 저장하는 것에 동의하는 것으로 간주됩니다.',
  cookie_accept_btn: '수락',
  cookie_reject_btn: '거부'
}